import { Action } from '@ngrx/store';

export const SHOW_SPINNER = "SHOW_SPINNER";
export const HIDE_SPINNER = "HIDE_SPINNER";

export interface IShowSpinnerPayload extends Action {
  showLoader: boolean;
}
export interface IHideSpinnerPayload extends Action {
  triggerAction: string;
}


export class ShowSpinner implements Action {
  type = SHOW_SPINNER;
  constructor(public payload?: IShowSpinnerPayload) {}
}

export class HideSpinner implements Action {
  type = HIDE_SPINNER;
  constructor(public payload?: IHideSpinnerPayload) { }
}
export type SystemLoaderActions = ShowSpinner | HideSpinner;
